import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=60e7a80b&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationsModal.vue?vue&type=style&index=0&id=60e7a80b&prod&scoped=true&lang=css"
import style1 from "./NotificationsModal.vue?vue&type=style&index=1&id=60e7a80b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7a80b",
  null
  
)

export default component.exports